import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber, parseIntNumber } from '@core/services/csv/CSVTransformer'
import { FrequencyList, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class AXATransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'AGENT CODE' = 'CODE 123'

  get advCode () {
    return this['AGENT CODE']
  }

  @Expose()
  private 'AGENT NAME' = 'Wen Adviser'

  get advName () {
    return this['AGENT NAME']
  }

  @Expose()
  @IsNotEmpty()
  private 'POLICY NUMBER' = 'Policy 123'

  get policyNumber () {
    return this['POLICY NUMBER']
  }

  @Expose()
  private 'ASSURED NAME' = 'John Doe'

  get clientName () {
    return this['ASSURED NAME']
  }

  @Expose()
  private 'ASSURED NRIC' = 'S00123'

  get clientNric () {
    return this['ASSURED NRIC']
  }

  @Expose()
  private 'BASIC PLAN CODE' = 'ABC001'

  get planCode () {
    return this['BASIC PLAN CODE']
  }

  @Expose()
  private 'BASIC OR RIDER PLAN' = 'Life Insurance Name'

  get planType () {
    return this['BASIC OR RIDER PLAN']
  }

  @Expose()
  private 'RIDER PLAN CODE' = 'ABC001'

  get componentCode () {
    return this['RIDER PLAN CODE']
  }

  get productType () {
    return ''
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'NON-LINKED PREMIUM' = 123.45

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'LINKED PREMIUM' = 123.45

  get premiumAmt () {
    return this['NON-LINKED PREMIUM'] + this['LINKED PREMIUM']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumPurpose))
  @IsOneOfThese(['RP', 'SP', 'RSP', 'TOP-UP'])
  private 'PREMIUM PURPOSE' = 'RP'

  get premiumPurpose () {
    return this['PREMIUM PURPOSE']
  }

  @Expose()
  @IsOneOfThese(FrequencyList.filter(frequency => !['RSP', 'Single'].includes(frequency)))
  private 'POLICY PAYMENT MODE' = 'Monthly'

  get payMode () {
    return FrequencyToValueMapping(this['POLICY PAYMENT MODE'] as FrequencyType)
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.policyYear))
  @IsNumber()
  private 'POLICY YEAR' = 13

  get policyYear () {
    return this['POLICY YEAR']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'POLICY ISSUE DATE' = '31/12/2020'

  get approvedDate (): number {
    return dateService.toUnixMilliseconds(this['POLICY ISSUE DATE'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.effectiveDate))
  @IsValidDate('DD/MM/YYYY')
  private 'COMMENCEMENT DATE' = '31/12/2020'

  get effectiveDate (): number {
    return dateService.toUnixMilliseconds(this['COMMENCEMENT DATE'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.paidToDate))
  @IsValidDate('DD/MM/YYYY')
  private 'POLICY PAID TO DATE' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['POLICY PAID TO DATE'], 'DD/MM/YYYY')
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'TOTAL COMMISSION' = 123.45

  get commissionAmt () {
    return this['TOTAL COMMISSION']
  }

  private 'Or Amt' = 0

  get orCommissionAmt () {
    return this['Or Amt']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'GST RATE' = 7

  get gstRate () {
    return this['GST RATE']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'GST AMOUNT' = 0.03

  get gstAmount () {
    return this['GST AMOUNT']
  }

  get productName () {
    return ''
  }
}
